import { ProtocolModel } from "../../models/risk-classification/protocol.model";
import { CompleteFlowchartStruct } from "./complete-flowchart.struct";

export class ProtocolStruct extends ProtocolModel {
    public listFlowchart: CompleteFlowchartStruct[];
}